import * as THREE from "three";

import "./css/style.css";
import nullstatic from "./images/Static.gif";
//Import logo images for loading screen
import logocenter from "./images/logo/Center.png";
import logorightside from "./images/logo/RightSide.png";
import logoleftside from "./images/logo/LeftSide.png";
import logobottomside from "./images/logo/Bottom.png";
import logostruts from "./images/logo/Struts.png";
import logotriangle from "./images/logo/Triangle.png";

import pictureofme from "./images/pictureofme.png";

import discordbackground from "./images/Timeline 3.gif";
import pfp from "./images/pfp.png";

import { Navbar } from "./Props";
import Mountains from "./js/Scenes/FxScene1";
import Earth from "./js/Scenes/FxScene2";
import Temple from "./js/Scenes/FxScene3";
import Logo from "./js/Scenes/FxScene4";

import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { collection, getDocs } from "firebase/firestore";
import { db, storage } from "../firebase";
import { ref, getDownloadURL } from "firebase/storage";
import { FirebaseError } from "firebase/app";

export default function main() {
  let current_scene, background_scene;
  window.onload = () => init();
  let renderer, renderer2, clock;
  let scrollPercent = 0;
  let current_scenehold = 0;
  let animationScripts = [];
  let loadingmanager = new THREE.LoadingManager();
  let scene0, scene1, scene2, scene3;

  const slogans = [
    "Build Higher.",
    "Apart Of Something More.",
    "Far Beyond, Far Above.",
    "Welcome Home, Neophyte.",
    "Defining Reality.",
    "Safe Haven And Response Directory.",
    "Callisto.",
    "ERROR! UNDEFINED CONSTRUCT!",
  ];

  document.body.onscroll = () => {
    //calculate the current scroll progress as a percentage
    scrollPercent =
      ((document.documentElement.scrollTop || document.body.scrollTop) /
        ((document.documentElement.scrollHeight || document.body.scrollHeight) -
          document.documentElement.clientHeight)) *
      100;
    //document.getElementById("scrollProgress").innerText =
    //"Scroll Progress : " + scrollPercent.toFixed(2);
  };

  function lerp(x, y, a) {
    return (1 - a) * x + a * y;
  }

  // Used to fit the lerps to start and end at specific scrolling percentages
  function scalePercent(start, end) {
    return (scrollPercent - start) / (end - start);
  }

  function playScrollAnimations() {
    animationScripts.forEach((a) => {
      if (scrollPercent >= a.start && scrollPercent < a.end) {
        a.func();
      }
    });
  }

  animationScripts.push({
    start: 0,
    end: 5,

    func: () => {
      document.getElementById("webgl").style.opacity = lerp(
        0,
        0.5,
        scalePercent(1, 0)
      );
      if (current_scenehold !== 0) {
        current_scene = scene0;
        current_scenehold = 0;
        background_scene = scene1;
      }
    },
  });

  animationScripts.push({
    start: 5,
    end: 30,

    func: () => {
      if (current_scenehold !== 1) {
        current_scene = scene2;
        current_scenehold = 1;
      }
    },
  });

  animationScripts.push({
    start: 30,
    end: 60,

    func: () => {
      if (current_scenehold !== 2) {
        current_scenehold = 2;
        current_scene = scene2;
        background_scene = scene1;
      }
      let v = lerp(0, 2, scalePercent(30, 0));
      document.getElementById("webgl").style.opacity = v * -1;
    },
  });

  animationScripts.push({
    start: 60,
    end: 101,

    func: () => {
      if (current_scenehold !== 3) {
        current_scenehold = 3;
        background_scene = scene3;
        current_scene = scene2;
      }
      let v = lerp(0, 3, scalePercent(71, 0));

      document.getElementById("webgl").style.opacity = v;
    },
  });

  loadingmanager.onProgress = function (url, itemsLoaded, itemsTotal) {
    var v = document.getElementById("loadingtext");

    var precentage = ((itemsLoaded / itemsTotal) * 100).toFixed(0);
    v.innerHTML = precentage + "% ";
    if (itemsLoaded === itemsTotal) {
      //Remove loading screen
      var l = document.getElementById("loading");
      if (l) {
        l.style.animationName = "fadeoutloading";
        setTimeout(
          () => {
            l.style.opacity = "0";
          },
          100,
          l
        );
        setTimeout(
          () => {
            l.style.display = "none";
          },
          1000,
          l
        );
      }
    }
  };

  function init() {
    const width = window.innerWidth,
      height = window.innerHeight;

    renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer2 = new THREE.WebGLRenderer({ antialias: true });
    renderer.setSize(width, height);
    renderer2.setSize(width, height);
    clock = new THREE.Clock();
    //aval scenes
    //Mountains(renderer)
    //Earth(renderer)
    //Temple(renderer)
    //Logo(renderer, loadingmanager, animationScripts);

    window.addEventListener("resize", onWindowResize, false);

    scene0 = Logo(renderer, loadingmanager, animationScripts);
    scene1 = Mountains(renderer2, loadingmanager, animationScripts);
    scene2 = Temple(renderer, loadingmanager, animationScripts);
    scene3 = Earth(renderer2, loadingmanager, animationScripts);
    current_scene = scene0;
    background_scene = scene1;
    appendWebglcon();
    animate();
  }
  async function appendWebglcon() {
    document.getElementById("Webglcon").appendChild(renderer.domElement);
    document.getElementById("Webglcon").appendChild(renderer2.domElement);
    renderer.domElement.classList.add("renderer-1st");
    renderer2.domElement.classList.add("renderer-2nd");
    renderer.domElement.id = "webgl";
    renderer2.domElement.id = "webgl2";
  }

  function animate() {
    requestAnimationFrame(animate);

    const delta = clock.getDelta();
    if (current_scene) {
      renderer.setRenderTarget(null);
      renderer.clear();
      renderer.render(current_scene.scene, current_scene.camera);
      playScrollAnimations();
    }
    if (background_scene) {
      renderer2.setRenderTarget(null);
      renderer2.clear();
      renderer2.render(background_scene.scene, background_scene.camera);
    }
  }

  function onWindowResize() {
    if (current_scene) {
      current_scene.camera.aspect = window.innerWidth / window.innerHeight;
      current_scene.camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
      renderer2.setSize(window.innerWidth, window.innerHeight);
    }
  }
  function Domainlist() {
    let list = [];
    let [websites, setWebsites] = useState([]);

    useEffect(() => {
      getDocs(collection(db, "Websites")).then((querySnapshot) => {
        setWebsites(querySnapshot.docs.map((doc) => doc.data()));
      });
    }, []);

    for (let index = 0; index < 15; index++) {
      if (websites[index]) {
        list.push(
          <li>
            <a href={websites[index].domain}>{websites[index].domain}</a>
          </li>
        );
      } else {
        list.push(
          <li>
            <a href="/">NULL</a>
          </li>
        );
      }
    }

    return <ul>{list}</ul>;
  }

  function Projectlist() {
    let list = [];
    let [projects, setProjects] = useState([]);
    let [images, setImages] = useState([]);
    //Magic :D

    useEffect(() => {
      getDocs(collection(db, "Projects")).then((querySnapshot) => {
        setProjects(querySnapshot.docs.map((doc) => doc.data()));
      });
    }, []);

    for (let index = 0; index < 5; index++) {
      if (projects[index] !== undefined) {
        const storageRef2 = ref(
          storage,
          "Content/" + projects[index].id + "/icon.png"
        );
        getDownloadURL(storageRef2)
          .then((url) => {
            const img = document.getElementById(
              "Foreground" + projects[index].id
            );
            img.setAttribute("src", url);
          })
          .catch((error) => {
            console.log(error);
          });

        list.push(
          <a href={"/content?id=" + projects[index].id} className="card">
            <div className="front">
              <img
                src={nullstatic}
                alt="Static"
                className="background"
                id={"Foreground" + projects[index].id}
              />
            </div>
            <div className="back">{projects[index].description}</div>
          </a>
        );
      } else {
        list.push(
          <a href="#null" className="card">
            <div className="front">
              <img src={nullstatic} alt="Static" className="background" />
              <h1>NULL OBJECT</h1>
            </div>
            <div className="back">NULL</div>
          </a>
        );
      }
    }
    return (
      <ul className="contentlist">
        <li>{list}</li>
      </ul>
    );
  }
  return (
    <>
      <div className="Loadingcover" id="loading">
        <div className="text">
          <h1 className="title-linebeam centerelements">S.H.A.R.D</h1>
          <p className="centerelements" id="slogan">
            {slogans[Math.floor(Math.random() * slogans.length)]}
          </p>
          <p className="centerelements">Loading...</p>
          <p id="loadingtext" className="centerelements">
            0%
          </p>
        </div>
        <div className="logo">
          <img src={logocenter} className="center" alt="center"></img>
          <img src={logorightside} className="right" alt="right"></img>
          <img src={logoleftside} className="left" alt="left"></img>
          <img src={logobottomside} className="bottom" alt="bottom"></img>
          <img src={logostruts} className="struts" alt="struts"></img>
          <img src={logotriangle} className="triangle" alt="triangle"></img>
        </div>
      </div>

      <p className="fixedshit" id="scrollProgress"></p>
      <Navbar fixed="true"></Navbar>
      <div id="Webglcon" className="">
        {/*<canvas data-engine="three.js r158" width="1455" height="708" style="display: block; width: 1455px; height: 708px;"></canvas>*/}
      </div>

      <section className="mainpage centerelements" id="Home">
        <div className="infomain">
          <h1 className="centerelements">Welcome To Shard</h1>
          <h2 className="centerelements">Version 0.6b</h2>
          <h3 className="centerelements">Purpose of this website</h3>
          <p className="text-center">
            Welcome to my portfolio, where I showcase my previous projects and
            professional journey. This platform serves to highlight my skills,
            creativity, and expertise across various disciplines. By presenting
            my work, I aim to demonstrate my problem-solving abilities,
            innovative approach, and commitment to quality. Whether you’re a
            potential client, employer, or collaborator, my portfolio is
            designed to provide insight into my capabilities and inspire future
            opportunities.
          </p>
        </div>
      </section>
      <section className="space"></section>
      <section className="mainpage centerelements" id="Projects">
        <div className="infoprojects">
          <h1 className="">Projects</h1>
          <div className="list">
            <ul>
              <li className="">
                <a href="/Contentlist?q=Games">Games</a>
              </li>
              <li>
                <a href="/Contentlist?q=Music">Music</a>
              </li>
              <li>
                <a href="/Contentlist?q=Misc">Misc</a>
              </li>
            </ul>
          </div>

          <div className="inner">
            <Projectlist></Projectlist>
          </div>
        </div>
      </section>
      <section className="space"></section>
      <section className="mainpage centerelements" id="About">
        <div className="about scrollproxy">
          <div className="inner">
            <div className="tophalf clearfix">
              <img className="main" src={pictureofme} alt="test500"></img>
              <div className="abouttext">
                <h1 className="centerelements">About</h1>
                <p>
                  Hello, my name is Evan, and I am a software developer with two
                  years of experience. I actively seek out diverse challenges
                  and embrace opportunities for continuous learning. In addition
                  to my professional pursuits, I have a strong passion for video
                  games and music. My fascination with computers has been a
                  driving force in my life since a young age, and I began
                  programming and creating music at the age of fifteen. One of
                  my most ambitious projects, Project Shard, showcases my skills
                  and dedication. I trust that you will find it as enjoyable as
                  I found the process of bringing it to life.
                </p>
              </div>
            </div>

            <div className="bottomhalf">
              <div className="websites">
                <h3 className="centerelements">Maintained Websites</h3>

                <div>
                  <Domainlist></Domainlist>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="space"></section>
      <section className="mainpage centerelements" id="Resources">
        <div className="resources">
          <h1 className="centerelements title">Resources/Contact</h1>
          <div className="contact">
            <div className="socials">
              <div className="discord">
                <img
                  src={discordbackground}
                  className="background"
                  alt="background"
                ></img>
                <div className="pfptext">
                  <img src={pfp} alt="shit" className="pfp"></img>
                  <div className="text">
                    <h1>SERVICE: Discord</h1>
                    <h2>NAME: Apera</h2>
                    <h3>ID: aperastrama</h3>
                  </div>
                </div>
              </div>
            </div>
            <h3 className="centerelements">OR</h3>
            <div className="email">
              <form className="">
                <label for="name">Name:</label>
                <input
                  className="name"
                  type="text"
                  id="name"
                  name="name"
                  required
                />
                <label className="" for="name">
                  Email:
                </label>
                <input
                  className="email"
                  type="text"
                  id="name"
                  name="name"
                  required
                />
                <label for="message">Message:</label>
                <textarea
                  className="message"
                  id="message"
                  name="message"
                  required
                ></textarea>
              </form>
            </div>
          </div>
          <div className="contacttext">
            <p>
            Please don't hesitate to reach out about my work or any questions you have. I will respond as quickly as I can because your inquiries are important to me. The best way to connect is through Discord.
            </p>
          </div>
        </div>
      </section>
      <section className="space"></section>
      <section className="mainpage centerelements">
        <div className="end">
          <h1 className="centerelements">Thanks for visting!</h1>
          <p className="centerelements">(C) 2024 E.W.G.R</p>
          <h3 className="centerelements">Credits</h3>
          <p className="centerelements">Earth Resources by NASA</p>
        </div>
      </section>
    </>
  );
}
